// extracted by mini-css-extract-plugin
export default {"spinWrapper":"Orders_spinWrapper__engbJ"};